import styled from "styled-components";

export const SubTitleContainerBox = styled.span`
    font-size: 15px;
    margin-bottom: 16px;
    ${({theme}) => theme.font.presets.regular};
`;